import { render, staticRenderFns } from "./ChiefComplaintsPopup.vue?vue&type=template&id=4b7286b1&scoped=true&"
import script from "./ChiefComplaintsPopup.vue?vue&type=script&lang=js&"
export * from "./ChiefComplaintsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChiefComplaintsPopup.vue?vue&type=style&index=0&id=4b7286b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7286b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7286b1')) {
      api.createRecord('4b7286b1', component.options)
    } else {
      api.reload('4b7286b1', component.options)
    }
    module.hot.accept("./ChiefComplaintsPopup.vue?vue&type=template&id=4b7286b1&scoped=true&", function () {
      api.rerender('4b7286b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChiefComplaints/ChiefComplaintsPopup.vue"
export default component.exports